import React from "react";

export default function AiDisclaimer({ title = "AI Disclaimer", detail = "" }) {
  return (
    <div className="rounded-lg border border-amber-300 bg-amber-50 px-3 py-2 text-amber-900">
      <p className="text-sm font-semibold">{title}</p>
      <p className="text-xs leading-5">
        {detail ||
          "AI results can be incomplete or inaccurate. Verify labels, quantities, contacts, and suggested line items before use."}
      </p>
    </div>
  );
}

